import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { of, switchMap } from 'rxjs';
import { AuthService } from '../auth.service';

export const NoAuthGuard: CanActivateFn | CanActivateChildFn = (route, state) =>
{
    const router: Router = inject(Router);
    const authService: AuthService = inject(AuthService);
    const platformId = inject(PLATFORM_ID);

    if (!isPlatformBrowser(platformId)) {
        return of(true);
    }

    // Check the authentication status
    return authService.check().pipe(
        switchMap((authenticated) =>
        {
            // If the user is authenticated...
            if ( authenticated )
            {
                const userRole = authService.getRole();
                if (userRole === 'student') {
                    return of(router.parseUrl('/student'));
                } else if (userRole === 'tutor') {
                    return of(router.parseUrl('/tutor'));
                }
                // If role is not defined, redirect to home
                return of(router.parseUrl(''));
            }

            // Allow the access
            return of(true);
        }),
    );
};
